var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email",
    d: "M23.333,3H4.667A4.68,4.68,0,0,0,0,7.667V19.333A4.68,4.68,0,0,0,4.667,24H23.333A4.68,4.68,0,0,0,28,19.333V7.667A4.68,4.68,0,0,0,23.333,3ZM25.2,9.767,15.983,15.95A3.933,3.933,0,0,1,14,16.533a3.933,3.933,0,0,1-1.983-.583L2.8,9.767a1.234,1.234,0,0,1-.233-1.633A1.234,1.234,0,0,1,4.2,7.9l9.217,6.183a1.264,1.264,0,0,0,1.283,0L23.917,7.9a1.147,1.147,0,0,1,1.633.35A1.273,1.273,0,0,1,25.2,9.767Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.d2acb60fe8e3b810cf208f3fc38f71c0.svg";
export { ForwardRef as ReactComponent };